"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Conversation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const headlineWords = [{
    text: "Diversity",
    italic: false
  }, {
    text: "is",
    italic: false
  }, {
    text: "our",
    italic: false
  }, {
    text: "strength;",
    italic: false
  }, {
    text: "inclusion",
    italic: false
  }, {
    text: "is",
    italic: false
  }, {
    text: "our",
    italic: false
  }, {
    text: "mission.",
    italic: true
  }];
  return <section data-section-id="19373" id="join-the-conversation" className="bg-background text-foreground py-36 md:py-52 px-6 md:px-14 overflow-hidden">
      <div ref={ref} className="mx-auto max-w-[1440px]">
        <div className="grid grid-cols-4 md:grid-cols-12 gap-4 md:gap-6">
          <div className="col-span-4 md:col-start-3 md:col-span-8 flex flex-col items-center text-center">
            <h2 className="font-default text-foreground" style={{
            fontSize: "clamp(2rem, 4.2vw, 3.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.02
          }}>
              <span className="inline-flex flex-wrap justify-center gap-x-[0.25em]">
                {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom">
                    <span className={`inline-block ${word.italic ? "italic" : ""}`} style={{
                  transform: isVisible ? "translateY(0%)" : "translateY(105%)",
                  opacity: isVisible ? 1 : 0,
                  transition: `transform 600ms cubic-bezier(0.2, 0.0, 0.0, 1.0) ${i * 40}ms, opacity 600ms cubic-bezier(0.2, 0.0, 0.0, 1.0) ${i * 40}ms`
                }}>
                      {word.text}
                    </span>
                  </span>)}
              </span>
            </h2>

            <p className="font-default text-foreground/80 mt-10 max-w-[60ch]" style={{
            fontSize: "clamp(1.0625rem, 1.3vw, 1.25rem)",
            fontWeight: 400,
            letterSpacing: "-0.005em",
            lineHeight: 1.55,
            transform: isVisible ? "translateY(0)" : "translateY(16px)",
            opacity: isVisible ? 1 : 0,
            transition: "transform 480ms cubic-bezier(0.2, 0.0, 0.0, 1.0) 280ms, opacity 480ms cubic-bezier(0.2, 0.0, 0.0, 1.0) 280ms"
          }}>
              Inclusive Voices News is dedicated to amplifying underrepresented perspectives and delivering unbiased truth. Join our community to stay informed, engage with meaningful multimedia, and help us build a more equitable future through shared knowledge.
            </p>

            <div className="mt-14 flex flex-col md:flex-row items-stretch md:items-center justify-center gap-4 w-full md:w-auto" style={{
            transform: isVisible ? "translateY(0)" : "translateY(16px)",
            opacity: isVisible ? 1 : 0,
            transition: "transform 480ms cubic-bezier(0.2, 0.0, 0.0, 1.0) 340ms, opacity 480ms cubic-bezier(0.2, 0.0, 0.0, 1.0) 340ms"
          }}>
              <Button asChild className="group h-12 px-7 bg-foreground text-background hover:bg-primary font-default font-medium tracking-wide">
                <Link to="/NewsroomPage">
                  <span>Explore our news</span>
                  <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-1" strokeWidth={1.5} />
                </Link>
              </Button>

              <Button asChild variant="outline" className="group h-12 px-7 bg-transparent border border-foreground text-foreground hover:bg-foreground hover:text-background font-default font-medium tracking-wide">
                <Link to="/ConnectPage">
                  <span>Join the community</span>
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}